import config from "../../../config.json";
import http from "../../../Services/httpService";

  

function sendMessage(data) { 
    return http.post(`${config.signalUrl}/api/chat/Post`,data);
}
function listMessage(data){ 
    return http.post(`${config.signalUrl}/api/chat/list`,data);
}
 
export default {
    sendMessage,listMessage
};
